<template>
  <z-dialog class="custom-user-dialog" :show="isVisible" :modalSize="modalSize">
    <template v-slot:header>
      <h4 class="modal-title">
        {{ title }}
      </h4>
      <button type="button" class="btn-close" @click="close"></button>
    </template>
    <template v-slot:body>
      <z-tabs v-model="currentTab" :tabs="tabs" @change="showTab" />
      <div class="row p-3" v-if="currentTab === 'Basic'">
        <user-basic
          ref="basic"
          :isAdd="isAdd"
          @saveIt="isSave = true"
          @emailFound="emailFound"
        />
      </div>
      <div class="row p-3" v-if="currentTab === 'Address'">
        <user-address ref="address" @saveIt="isSave = true" />
      </div>
      <div class="row p-3" v-if="currentTab === 'Avatar'">
        <user-avatar ref="avatar" />
      </div>
      <div class="row p-3" v-if="currentTab === 'Organization'">
        <user-organization
          ref="organization"
          :isAdd="isAdd"
          @saveIt="isSave = true"
        />
      </div>
      <div class="row p-3" v-if="currentTab === 'Password'">
        <user-password ref="password" :isAdd="isAdd" @saveIt="isSave = true" />
      </div>
      <div class="row p-3" v-if="currentTab === 'Subscribe' && !isProfile">
        <user-subscribe ref="subscribe" @saveIt="isSave = true" />
      </div>
      <div class="row p-3" v-if="currentTab === 'Messages' && !isProfile">
        <user-messages ref="messages" />
      </div>
      <div class="row p-3" v-if="currentTab === 'Options' && !isProfile">
        <user-options ref="options" />
      </div>
    </template>
    <template v-slot:footer>
      <div class="row custom-footer">
        <div class="col-md-1">
          <span title="org id / user id">#{{ ids }}</span>
        </div>
        <div class="col-md-2">
          <button class="btn btn-secondary" @click="confirmDelete">
            Delete Account
          </button>
        </div>
        <div class="col">
          <span v-if="invalidMessage !== ''" class="custom-invalid">{{
            invalidMessage
          }}</span>
        </div>
        <div class="col-md-4">
          <div class="custom-buttons">
            <button
              v-show="isSave"
              class="btn btn-primary me-2"
              @click="performSave(false)"
            >
              Save
            </button>
            <button
              v-show="isSave && !isAdd"
              class="btn btn-primary me-2"
              @click="performSave(true)"
            >
              Save and Close
            </button>
            <button type="button" class="btn btn-secondary me-2" @click="close">
              Close
            </button>
          </div>
        </div>
      </div>
    </template>
  </z-dialog>
  <confirm-delete
    class="custom-confirm-delete"
    :show="actionConfirmDelete"
    :confirmTitle="confirmTitleDelete"
    :confirmAction="confirmActionDelete"
    :confirmQuestion="confirmQuestionDelete"
    @closing="closeModal"
    @proceed="performDelete"
  />
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import ZDialog from '@/Components/ZElements/Dialog'
import ZTabs from '@/Components/ZElements/Tabs'
import UserBasic from '@/Components/Users/forms/user-basic'
import UserAddress from '@/Components/Users/forms/user-address'
import UserOrganization from '@/Components/Users/forms/user-organization'
import UserPassword from '@/Components/Users/forms/user-password'
import UserAvatar from '@/Components/Users/forms/user-avatar'
import UserMessages from '@/Components/Users/forms/user-messages'
import UserSubscribe from '@/Components/Users/forms/user-subscribe'
import UserOptions from '@/Components/Users/forms/user-options'
import ConfirmDelete from '@/Components/ZElements/ConfirmDialog'
export default {
  name: 'user-dialog',
  components: {
    ZDialog,
    ZTabs,
    UserBasic,
    UserAddress,
    UserOrganization,
    UserPassword,
    UserAvatar,
    UserMessages,
    UserSubscribe,
    UserOptions,
    ConfirmDelete,
  },
  props: {
    show: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      modalSize: 'modal-xl',
      currentTab: 'Basic',
      isSave: false,
      validErrors: [],
      invalidMessage: '',
      confirmTitleDelete: 'Confirm Delete Account',
      confirmActionDelete: 'Delete Account',
      confirmQuestionDelete:
        'This will permanently DELETE your account. Are you sure you wish to DELETE Account?',
      actionConfirmDelete: null,
    }
  },
  mounted() {
    this.isSave = false
    this.validErrors = []
    this.invalidMessage = ''
  },
  computed: {
    ...mapGetters('users', ['user']),
    isVisible() {
      return this.show !== null
    },
    tabs() {
      let _tabs = ['Basic', 'Address', 'Password']
      if (this.isProfile) {
        _tabs.push('Avatar')
      } else if (!this.isAdd) {
        _tabs.push('Avatar')
        _tabs.push('Organization')
        _tabs.push('Subscribe')
        _tabs.push('Messages')
      }
      return _tabs
    },
    isAdd() {
      let _is = false
      if (this.show) {
        if (this.show.isAdd) {
          _is = true
        }
      }
      return _is
    },
    title() {
      let _title = 'Edit User'
      if (this.show) {
        if (this.show.isAdd) {
          _title = 'Add User'
        } else if (this.user) {
          _title = `Edit User (${this.user.detail.firstName} ${this.user.detail.lastName})`
        }
      }
      return _title
    },
    ids() {
      let _ids = ''
      if (this.user) {
        _ids = this.user.detail.id
      }
      return _ids
    },
    isProfile() {
      let _is = false
      if (this.show) {
        if (this.show.cameFrom === 2) {
          _is = true
        }
      }
      return _is
    },
  },
  methods: {
    ...mapActions('users', ['saveUser', 'deleteUser']),
    showTab(value) {
      if (this.show.isAdd) {
        this.currentTab = value
      } else {
        let saved = false
        if (this.isSave) {
          saved = this.performSave(false)
        } else {
          saved = true
        }
        if (saved) {
          this.currentTab = value
          this.isSave = false
        }
      }
    },
    closeModal() {
      this.actionConfirmDelete = null
    },
    emailFound() {
      let $this = this
      console.log('showing found message')
      this.invalidMessage =
        'Notice: Email address already in use. Your new User will not save.'
      setTimeout(() => {
        $this.invalidMessage = ''
      }, 3000)
    },
    confirmDelete() {
      this.actionConfirmDelete = true
    },
    async performDelete() {
      console.log('Deleting', this.user)
      await this.deleteUser(this.user.detail.id)
      this.$emit('deleted')
    },
    validate() {
      let valid = true
      this.validErrors = []
      this.invalidMessage = ''
      if (this.user.detail.firstName === '') {
        valid = false
        this.validErrors.push('first name')
      }
      if (this.user.detail.lastName === '') {
        valid = false
        this.validErrors.push('last name')
      }
      if (this.user.detail.email === '') {
        valid = false
        this.validErrors.push('email')
      }
      if (this.user.detail.phoneCell === '') {
        valid = false
        this.validErrors.push('cell phone')
      }
      if (this.show.isAdd) {
        if (this.user.detail.password === '') {
          valid = false
          this.validErrors.push('password')
        } else if (this.user.detail.password2 === '') {
          valid = false
          this.validErrors.push('confirm password')
        } else if (this.user.detail.password !== this.user.detail.password2) {
          valid = false
          this.validErrors.push(`passwords don't match`)
        }
      }
      return valid
    },
    async performSave(closeIt) {
      let success = false
      let valid = this.validate()
      if (valid) {
        // Save Here
        success = true
        let saved = true
        console.log('Saved', {
          closeId: closeIt,
          isAdd: this.show.isAdd,
          user: this.user,
        })
        await this.saveUser(this.user.detail)
        this.isSave = false
        this.$emit('saved', saved)
        if (closeIt || this.show.isAdd) {
          this.currentTab = 'Basic'
          this.$emit('close')
        }
      } else {
        this.invalidMessage = 'missing ' + this.validErrors.join(', ')
      }
      return success
    },
    close() {
      this.currentTab = 'Basic'
      this.$emit('close')
    },
  },
}
</script>
<style scoped>
.custom-user-dialog {
  color: #000;
}
.custom-header {
  width: 100%;
}
.custom-body {
  max-height: 650px;
  overflow-x: hidden;
  overflow-y: scroll;
}
.custom-footer {
  width: 100%;
  text-align: left;
}
.custom-invalid {
  color: red;
  font-weight: 500;
}
.custom-buttons {
  position: relative;
  float: right;
}
.custom-confirm-delete {
  color: #000;
}
</style>
